import { FormEvent, useRef, useState } from 'react'
import { SlideOutModal, SlideOutModalProps, TextWithValidation } from '../../../../components'
import sharedProperty from '../../../../app/sharedProperty'
import { BlogAuthorModel } from '../../../../data/entities';
import { Button, Form } from 'react-bootstrap';

interface EditAuthorModalProps extends SlideOutModalProps {
  dataItemState: sharedProperty<BlogAuthorModel>;
  onSubmit: (data: BlogAuthorModel) => void;
}

export function EditAuthorModal(props: Readonly<EditAuthorModalProps>) {
  
  const [validated, setValidated] = useState(false);

  const formRef = useRef<HTMLFormElement>(null);
  const formSubmitRef = useRef<HTMLButtonElement>(null);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setValidated(true);
      props.onSubmit.call(null, props.dataItemState.value);
      setValidated(false);
    } else {
      setValidated(false);
    }
  };

  const patchDataItem = (patch: Object) => {
    props.dataItemState.setter({ ...props.dataItemState.value, ...patch });
  }
  
  return (
    <SlideOutModal {...props}
      title={`Edit Author ${props.dataItemState.value.displayName}`}
      footer={<div className="container p-0">
        <div className="row g-0">
          <div className="col-6 pe-2">
            <Button onClick={() => props.showState.setter(false)} variant="cancel" className="w-100">
              Cancel
            </Button>
          </div>
          <div className="col-6 ps-2">
            <Button onClick={() => formSubmitRef.current?.click()} variant="primary" className="w-100">
              Update
            </Button>
          </div>
        </div>
      </div>}>
      <Form ref={formRef} noValidate validated={validated} onSubmit={handleSubmit}>
        <div className="col-12">
          <TextWithValidation
            id="avatarUrl"
            required={true}
            label="Avatar Image URL"
            initialValue={props.dataItemState.value.imageUrl}
            onChangeText={(v) => patchDataItem({ imageUrl: v })}
          /> 
        </div>
        <div className="col-12">
          <TextWithValidation
            id="firstName"
            required={true}
            label="First Name"
            initialValue={props.dataItemState.value.firstName}
            onChangeText={(v) => patchDataItem({ firstName: v })}
          /> 
        </div>
        <div className="col-12">
          <TextWithValidation
            id="lastName"
            required={true}
            label="Last Name"
            initialValue={props.dataItemState.value.lastName}
            onChangeText={(v) => patchDataItem({ lastName: v })}
          /> 
        </div>
        <div className="col-12">
          <TextWithValidation
            id="displayName"
            required={true}
            label="Display Name"
            initialValue={props.dataItemState.value.displayName}
            onChangeText={(v) => patchDataItem({ displayName: v })}
          /> 
        </div>
        <div className="col-12">
          <TextWithValidation
            id="signature"
            required={true}
            label="Signature"
            initialValue={props.dataItemState.value.signature}
            onChangeText={(v) => patchDataItem({ signature: v })}
          />
        </div>
        <Button ref={formSubmitRef} type="submit" className="d-none" />
      </Form>
      {props.children}
    </SlideOutModal>
  )
}

export default EditAuthorModal
